<template>
    <div class="position-relative">
        <div class="position-absolute" style="top:1em;right:0px;">
            <div class="pull-right">
                <multiselect
                        :options="sorting_options"
                        v-model="sorting"
                        track-by="key"
                        label="name"
                        :preselect-first="true"
                        :searchable="false"
                        :allow-empty="false"
                        :close-on-select="true"
                        :show-labels="false"
                        :multiple="false"
                        style="min-width:100px"
                >
                </multiselect>
            </div>
            <div class="pull-right mr-2">
                <div class="d-inline-block form-control-plaintext">
                    {{ trans[locale].sort_by }}
                </div>
            </div>
        </div>
        <div class="section-title">
            {{ album_category.name }} <i class="fa fa-spinner fa-spin" v-if="$store.state.submitting"></i>
        </div>
        <thumb-listing :url="album_url"
                       init_table_class="digitalch"
                       :ignore_total_string="false"
                       :extract_hook_success_callback=true
                       element_id="selector_albums"
                       :ignore_query_string="true"
                       v-show="!$store.state.submitting"
        >
            <template slot="scopeListing" slot-scope="scopeListing">
                <div class="list-item draggable valign_top draggable-item" v-for="(row, key) in scopeListing.listing_data.data">
                    <div class="thumb bg-light" @click="selectAlbum(row)">
                        <img :src="row.thumbnail_url" class="d-block">
                    </div>
                    <div class="album-title">{{ row.name }}</div>
                    <div class="number-text">({{ row.no_of_media }})</div>
                    <div class="date">{{ row.album_date }}</div>
                </div>
            </template>
        </thumb-listing>
    </div>
</template>

<script>
    export default {
        name: "AlbumSelector",
        data() {
            return Object.assign({
                trans: {
                    'zh-HK' : {
                        sort_by: '排序:',
                    },
                    'en' : {
                        sort_by: 'Sort by:',
                    }
                },
                album_year: {},
                album_category: {},
                keyword: '',
                query_str: '',
                sorting_options: this.init_sorting_options,
                sorting: this.init_sorting,
            }, { locale: window.locale })
        },
        beforeMount() {
            window.eventHub.$off('retrieve-album-list', this.fetchAlbumList);
        },
        mounted() {
            window.eventHub.$on('retrieve-album-list', this.fetchAlbumList);
        },
        props: {
            init_sorting_options: {
                required:false,
                type: Array,
                default: () => {
                    return [];
                }
            },
            init_sorting: {
                required:false,
                type: Object,
                default: () => {
                    return {};
                }
            },
        },
        computed: {
            album_url() {
                let url = _.isUndefined(this.album_category.album_list_url)
                    ? ''
                    : this.album_category.album_list_url;

                if (url != '')
                {
                    if (url.includes('?')) {
                        url += '&' + this.query_str;
                    } else {
                        url += '?' + this.query_str;
                    }
                    if (!_.isUndefined(this.sorting.key) && this.sorting.key != 'default')
                    {
                        url += '&sort=' + this.sorting.key;
                    }
                }
                return url;
            }
        },
        methods: {
            fetchAlbumList(param) {
                this.album_year = param.year;
                this.album_category = param.category;
                this.keyword = param.keyword;
                this.query_str = param.query_str;
            },
            selectAlbum(album) {
                window.eventHub.$emit('show-media-listing', true);

                this.$nextTick(function() {
                    let param = {
                        category_keyword: this.keyword,
                        keyword: '',
                        album: album
                    }
                    window.eventHub.$emit('update-keyword', '');
                    window.eventHub.$emit('retrieve-media-list', param);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DigitalChannelMediaPicker/AlbumSelector.vue